<template>
  <v-container class="text-left" fluid>
    <v-row>
      <v-col md="12">
        <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
        <v-data-table
          :headers="headers"
          :options.sync="options"
          :server-items-length="serverItemsLength"
          v-show="!loading"
          :items="users"
        >
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import userAPI from '@/api/user.js';

export default {
  name: 'PartnerUsers',
  components: {
    
  },
   props: {
    userId: {
      type: String
    }
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Last Login', value: 'last_login', sortable: false },
      ],
      companyId: this.$route.params.id,
      users: [],
      searchParams: `&partner_id=${this.userId}`,
      pagination: {},
      options: {},
      loading: false,
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
  },
  methods: {
    getUsers() {
      this.loading = true;
      userAPI
        .getClients(this.params, this.searchParams)
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
  },
};
</script>
